window.dataLayer = window.dataLayer || []

// Track which video IDs have already fired video_play this page load.
// Prevents re-firing on pause → resume cycles.
const ga4PlayedVideoIds = new Set()

const onPlayerStateChange = (event, isAutoplay = false) => {
    let state = event.data
    const videoUrl = event.target.v.videoUrl

    // GA4 video_play: fires once per video per page load, on first manual play only.
    if (state === 1 && !isAutoplay) {
        const videoData = event.target.getVideoData ? event.target.getVideoData() : {}
        const videoId = videoData.video_id || videoUrl
        if (videoId && !ga4PlayedVideoIds.has(videoId)) {
            ga4PlayedVideoIds.add(videoId)
            window.dataLayer.push({
                event: 'video_play',
                video_title: videoData.title || '',
                video_percent: 0,
            })
        }
    }
}

export { onPlayerStateChange }
